import { Link } from "@faire/web--source/ui/LinkAnchor";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import React, { useContext } from "react";

import {
  TrackedLink,
  TrackedLinkContext,
} from "@faire/retailer/components/TrackedLink";

/**
 * Component that understands that MarketplaceProduct should be wrapped in a
 * TrackedLinkContext that provides the context for tracking a product click
 * and derives what a brand click should look like.
 */
export const MarketplaceProductBrandLink: React.FC<TrackedLink.IProps> = (
  props
) => {
  const context = useContext(TrackedLinkContext);
  const { to, children, ...linkProps } = props;

  if (!context) {
    if (to === undefined) {
      return <>{children}</>;
    }
    return (
      <Link to={to} {...linkProps}>
        {children}
      </Link>
    );
  }

  return (
    <TrackedLinkContext.Provider
      value={{
        type: IClickInfo.Type.BRAND,
        containerName: `${context.containerName}_brand`,
        requestId: context.requestId || "",
      }}
    >
      <TrackedLink {...props}>{children}</TrackedLink>
    </TrackedLinkContext.Provider>
  );
};
